<template>
  <div class="role">
    <div class="opreationBox">
      <el-form
        :inline="true"
        :model="params"
        class="demo-form-inline"
        label-width="100px"
        @submit.native.prevent
      >
        <el-form-item label="角色名称">
          <el-input
            placeholder="请输入角色名称"
            clearable
            v-model="params.name"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="">
          <el-button
            style="width:98px"
            type="primary"
            @click="handleCurrentChange(1)"
          >
            查询
          </el-button>
          <el-button
            style="width:98px"
            type="danger"
            plain
            @click="reset"
          >
            重置
          </el-button>
        </el-form-item>
        <el-form-item
          label=""
          style="float:right"
        >
          <el-button
            style="width:128px"
            type="primary"
            @click="addAuth"
          >
            新增角色
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="tableBox">
      <el-table
        v-loading="loading"
        :height="tableH"
        :data="dataList"
        border
        style="width: 100%"
      >
        <el-table-column
          header-align="center"
          prop="roleName"
          label="角色名称"
          align="center"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="操作"
        >
          <template slot-scope="scope">
            <el-button
              plain
              size="mini"
              @click="updateAuth(scope.row)"
              style="margin-bottom: 10px;"
            >
              更新权限
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pageBox" style="text-align: right;margin-top: 10px;">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="params.pageIndex"
        :page-sizes="[2, 4, 10, 20, 50, 100]"
        :page-size="params.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <authDialog ref="authDialog" @done="authDone" />
  </div>
</template>

<script>
  import { rolepermissionpage as getList } from 'api/request'
  import { SetTableH } from '../../utils/utils'
  import authDialog from "./components/authDialog";
  export default {
    name: 'Role',
    components: {
      authDialog
    },
    data() {
      return {
        params: {
          pageIndex: 1,
          pageSize: 10,
          name: undefined
        },
        total: 0,
        dataList: [],
        loading: true,
        tableH: '250'
      }
    },
    created() {
      this.getList()
    },
    mounted() {
      SetTableH(this)
    },
    methods: {
      async getList() {
        let data = await getList(this.params)
        if (data) {
          this.dataList = data.rows
          this.total = data.total
          this.loading = false
        }
      },
      reset() {
        for (let key in this.params) {
          this.params[key] = ''
        }
        this.params.pageIndex = 1
        this.params.pageSize = 10
        this.handleCurrentChange(1)
      },
      handleSizeChange(val) {
        this.params.pageSize = val
        this.getUserList()
      },
      handleCurrentChange(val) {
        this.params.pageIndex = val
        this.getList()
      },
      addAuth() {
        this.$refs.authDialog.show({})
      },
      updateAuth(data) {
        this.$refs.authDialog.show(JSON.parse(JSON.stringify(JSON.parse(JSON.stringify(data)))))
      },
      authDone(id) {
        id ? this.getList() : this.handleCurrentChange(1)
      },
    }
  }
</script>
